"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createComponentInitStateSelector = void 0;

var _reselect = require("reselect");

var _createShallowEqualSelector = _interopRequireDefault(require("./utils/createShallowEqualSelector"));

var _actionTypes = require("./actions/actionTypes");

var _extractValuesForProps = _interopRequireDefault(require("./utils/extractValuesForProps"));

var _initMode = require("./initMode");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Reducer function that manages the state for `react-redux-component-init`. This reducer should
 * be included using Redux's `combineReducers()` under the `init` key in the root of
 * the store state.
 */
var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    mode: _initMode.MODE_PREPARE,
    prepared: {},
    selfInit: {}
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _actionTypes.SET_INIT_MODE:
      return _objectSpread(_objectSpread({}, state), {}, {
        mode: action.payload
      });

    case _actionTypes.INIT_COMPONENT:
      if (action.payload.isPrepare) {
        return _objectSpread(_objectSpread({}, state), {}, {
          prepared: _objectSpread(_objectSpread({}, state.prepared), {}, _defineProperty({}, action.payload.prepareKey, action.payload.complete))
        });
      }

      return _objectSpread(_objectSpread({}, state), {}, {
        selfInit: _objectSpread(_objectSpread({}, state.selfInit), {}, _defineProperty({}, action.payload.prepareKey, action.payload.complete))
      });

    default:
      return state;
  }
};

exports.default = _default;

var createComponentInitValuesSelector = function createComponentInitValuesSelector(_ref) {
  var componentId = _ref.componentId,
      initProps = _ref.initProps,
      getPrepareKey = _ref.options.getPrepareKey;
  return (0, _createShallowEqualSelector.default)(function (state, props) {
    return (0, _extractValuesForProps.default)(props, initProps);
  }, function (initValues) {
    return {
      prepareKey: getPrepareKey(componentId, initValues),
      initValues: initValues
    };
  });
};

var createComponentInitStateHelperSelector = function createComponentInitStateHelperSelector(initConfig) {
  return (0, _reselect.createSelector)(createComponentInitValuesSelector(initConfig), function (state) {
    return state.selfInit;
  }, function (state) {
    return state.prepared;
  }, function (_ref2, selfInit, prepared) {
    var prepareKey = _ref2.prepareKey,
        initValues = _ref2.initValues;
    return {
      prepareKey: prepareKey,
      initValues: initValues,
      selfInitState: selfInit[prepareKey],
      preparedState: prepared[prepareKey]
    };
  });
};

var createComponentInitStateSelector = function createComponentInitStateSelector(initConfig) {
  return (0, _createShallowEqualSelector.default)(createComponentInitStateHelperSelector(initConfig), function (_ref3) {
    var prepareKey = _ref3.prepareKey,
        initValues = _ref3.initValues,
        selfInitState = _ref3.selfInitState,
        preparedState = _ref3.preparedState;
    return {
      prepareKey: prepareKey,
      initValues: initValues,
      selfInitState: selfInitState,
      isPrepared: !!preparedState
    };
  });
};

exports.createComponentInitStateSelector = createComponentInitStateSelector;